import { getFontScale } from 'mini-app-module-store/lib/selectors/getFontScale';

/**
 * The function is used to bind the fontScale on both sides. 3 arguments are passed to the function: the size, the lower bound and the upper bound.
 *
 */

export const scaleElementFontSize = (
    defaultSize: number,
    lowerBound: number = -Infinity,
    upperBound: number = Infinity
) => defaultSize * Math.min(Math.max(getFontScale(), lowerBound), upperBound);

/**
 * The function is used to bind the final size on both sides. 3 arguments are passed to the function: the size, the lower bound and the upper bound.
 *
 */
export const scaleElementBindFinalSize = (defaultSize: number, upperBound: number = Infinity) =>
    Math.min(getFontScale() * defaultSize, upperBound);
